import React, {useState, useEffect, useMemo} from 'react'
import MultiSelectBtn from '../multiSelectBtn'
import { useGetDevice } from "../../../../api/userInfo";
import { SelectChartIcon, SelectNormalIcons } from "../../SetupWidget/SelectWidgetIcon";
import { ElevatorSharp } from '@mui/icons-material';
import { InputWithLabel } from 'src/components/ui/inputFields/input-with-label';
import CustomColorSelect from 'src/components/ui/inputFields/custom-color-select';

const MultiFieldWithIconItem = ({removeField, fieldIndex, totalFields, selectedWidget, deviceList, defaultValue, updateSetupDetails, setupDetails, isChart}) => {
    const [multiSelect,setMultiSelect ]= useState({})
    const [data, setData] =useState(defaultValue)

    useEffect(() => {
        if(multiSelect?.deviceFields?.length>0){
            document.getElementById(`select-field-${fieldIndex}`).removeAttribute('disabled')
        }else{
            document.getElementById(`select-field-${fieldIndex}`).setAttribute('disabled', true)
        }
        // if(multiSelect?.data){
        //     handleChange(multiSelect?.data, multiSelect?.field)  
        // }
    }, [multiSelect]);

    useEffect(() => {
        if(defaultValue){
            setData(defaultValue)
        }
    }, []);

    const handleChange = (value, field) => {
            setData(prevData => ({
                ...prevData,
                [field]: value   
              }));
    }

    useEffect(() => {
        if(data){
            const updatedMeasurement = setupDetails?.measurement ?? []; //a copy of the measurement array
            updatedMeasurement[fieldIndex] = data; // Update the specific element

            updateSetupDetails({
                ...setupDetails,
                "measurement": updatedMeasurement
            });
        }
    }, [data]);

    const onInput = (field, type_) => (e) => {
        const [fieldName, fieldIndex] = field.split("-")
        const fieldValue = type_ === 'isBoolean' ? (e.target.value === 'true') : e.target.value;

        // this works, but the field property should have all details
        // if(type_ === "hasUnit"){
        //     console.log("we got here",multiSelect?.deviceFields )
        //     const inputs = {
        //         [fieldName]: fieldValue,
        //         "unit": multiSelect?.deviceFields?.find(({field}) => field  === fieldValue)?.unit //to set unit for users once they select device
        //     }
        //     handleChange(inputs, "hasUnit")  
        // }else{
            handleChange(fieldValue, fieldName)
        
    };
    
    
    return ( 
            <div className="flex flex-col gap-4 mt-4 mb-10 " >
                    <div className="relative flex flex-col gap-2">
                  {totalFields && <button onClick={() => removeField(fieldIndex)} type='button' className='absolute right-0 inline-flex items-center px-1 text-[11px] text-red-400 border rounded-md -top-0 border-red-400/60 hover:bg-red-400/60 hover:text-white'>
                    <i className="ri-close-circle-line"></i>Remove</button> }
                        <label htmlFor={`device-${fieldIndex}`} className="col-span-1 text-sm text-gray-500">Device ID (select one or more devices)</label>
                        <MultiSelectBtn
                            handleDeviceChange={handleChange}
                            setMultiSelect={setMultiSelect} 
                            deviceDetail = {data?.device}
                            placeholder="select device"
                            isSpecialType={true}
                            index={fieldIndex}
                            data={deviceList} 
                            name="device" 
                            
                        />

                    </div> 
            
                
                    <div className="grid grid-cols-10 gap-2">
                        <InputWithLabel label="Name" placeholder="Name of device" name={`title-${fieldIndex}`} required 
                            onChange={onInput(`title-${fieldIndex}`)} 
                            defaultValue={data?.title}
                            />


                        <InputWithLabel label="Unit" placeholder="kWh" name={`unit-${fieldIndex}`} required className="col-span-2"
                            onChange={onInput(`unit-${fieldIndex}`)} 
                            defaultValue={data?.unit}
                            />

                        <div  className="flex flex-col col-span-4 gap-2">
                            <label htmlFor={`field-${fieldIndex}`} className="col-span-1 text-sm text-gray-500"> Select Field</label>
                            <select id={`select-field-${fieldIndex}`} name={`field-${fieldIndex}`} className="setupModal_input" onChange={onInput('field')} disabled value={data?.['field']}>
                                {/* TODO: to refactor */}
                                {multiSelect?.deviceFields?.length ===undefined && <option>You need to first select the device/s</option>}
                                {multiSelect?.deviceFields?.length !==undefined && <option value={''}>{multiSelect?.info}</option>}
                                {multiSelect?.deviceFields?.map(({name, field}, index) => (
                                    <option key={index+field} value={field} >{name}</option>
                                ))}
                            </select>
                        </div>

                    </div>
                    
                    <div className='flex flex-row gap-10'>
                        {isChart &&
                            <CustomColorSelect 
                            defaultColor={data?.['color']??'#363535'} 
                            setColorSelect={handleChange}
                            index={fieldIndex} 
                            label={'Select Color'} 
                            name={`color-${fieldIndex}`}/>
                        }

                        <div className='flex flex-col gap-2'>
                            <label htmlFor={`icon-${fieldIndex}`} className="col-span-1 text-sm text-gray-500">Select Icon</label>
                            <SelectChartIcon 
                            index={fieldIndex}
                            defaultIcon={data?.icon}
                            setIconSelect={handleChange} 
                            selectedColor={data?.['color']} 
                            selectedWidget={selectedWidget} />  
                    {/* <SelectNormalIcons updateSetupDetails={updateSetupDetails} setupDetails={setupDetails} defaultIcon={widgetDetails?.setup?.icon}/>  */}

                        </div>

                      {/* //showYAxis  ---> TODO: to refactor */}
                      {(selectedWidget == 'Line Chart') &&
                        <div className='flex flex-col gap-1'>
                            <p className="col-span-1 text-sm text-gray-500">show grouped data Y-Axis?</p>

                            <div className='flex flex-row gap-4'>
                                <label htmlFor={`show_y_axis-${fieldIndex}`} className='inline-flex items-center gap-2' >
                                    <input onChange={onInput(`show_y_axis-${fieldIndex}`, 'isBoolean')} value={true}  required type="radio" 
                                    name={`show_y_axis-${fieldIndex}`} className="w-4 h-4 accent-vekin" placeholder="_ac_energy" checked={data?.showYAxis==true || data?.show_y_axis==true}/>  
                                    Yes
                                </label>

                                <label htmlFor={`show_y_axis-${fieldIndex}`}  className='inline-flex items-center gap-2' >
                                    <input onChange={onInput(`show_y_axis-${fieldIndex}`, 'isBoolean')} value={false}  required type="radio" 
                                    name={`show_y_axis-${fieldIndex}`} className="w-4 h-4 accent-vekin" placeholder="_ac_energy" checked={data?.showYAxis==false || data?.show_y_axis==false}/>  
                                    No
                                </label>
    
                            </div>
                            
                            
                            
                        </div>
                        }
                        
                    </div>

            </div>
     );
}
 
export default MultiFieldWithIconItem;